import { render, staticRenderFns } from "./FolderModal.vue?vue&type=template&id=4832e50a&"
import script from "./FolderModal.vue?vue&type=script&lang=js&"
export * from "./FolderModal.vue?vue&type=script&lang=js&"
import style0 from "./FolderModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports